import { useState } from 'react';
import { Breadcrumb, Button, Layout, Typography } from 'antd';
import CustomerSidebar from './siderbar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ModalForm from '../pages/adminPortal/towingtariff/ModalForm';
import ScheduleForm from '../pages/adminPortal/schedule/ScheduleForm'
import { checkPermission } from '../utils/permissions';
import { PresenceProvider } from "../context/PresenceContext";
import GlobalRingingListener from "../components/GlobalRingingListener";
import HeaderComponent from './header';
import { COMPANY_LOGO, ROLES } from '../constants';
import TopTicker from './TopTicker';
import Sidebar from './siderbar';
import BottomSidebar from './BottomSidebar';
const { Content, Footer } = Layout;
const { Title } = Typography;

export default function FinalLayout({ children, title }) {
    const user = JSON.parse(localStorage.getItem("user"));

    const navigate = useNavigate()
    const location = useLocation();

    // const loggedInUser = JSON.parse(localStorage.getItem("user"));
    const role = localStorage.getItem('role')

    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [isAddModalSchedule, setIsAddModalSchedule] = useState(false);
    const [editData, setEditData] = useState(null);

    const showAddModal = () => {
        setIsAddModalVisible(true);
        setEditData(null);
    };

    const handleScheduleCancel = () => {
        setIsAddModalSchedule(false)
    }

    const handleAddCancel = () => {
        setIsAddModalVisible(false);
    };

    const appointmentMenu = [
        checkPermission('VIEW_APPOINTMENTS') && { title: "Browse", path: "/operations/appointment" },
        checkPermission('ADD_APPOINTMENTS') && { title: "Add", path: "/operations/appointment/add" },
    ].filter(Boolean);

    const breadcrumbMap = {
        ...(role !== ROLES.CUSTOMER && {
            "/vehicle": [
                checkPermission('VIEW_VEHICLES') && { title: "Browse", path: "/vehicle" },
                checkPermission('ADD_VEHICLE') && { title: "Add", path: "/vehicle/add" },
                // checkPermission('EXPORT_VEHICLE') && { title: "Export", onClick: () => showExportModal() },
            ].filter(Boolean),
            "/vehicle/add": [
                checkPermission('VIEW_VEHICLES') && { title: "Browse", path: "/vehicle" },
                checkPermission('ADD_VEHICLE') && { title: "Add", path: "/vehicle/add" },
                // checkPermission('EXPORT_VEHICLE') && { title: "Export", onClick: () => showExportModal() },
            ].filter(Boolean),
            "/vehicle/edit": [
                checkPermission('VIEW_VEHICLES') && { title: "Browse", path: "/vehicle" },
                checkPermission('ADD_VEHICLE') && { title: "Add", path: "/vehicle/add" },
                // checkPermission('EXPORT_VEHICLE') && { title: "Export", onClick: () => showExportModal() },
            ].filter(Boolean),
        }),
        // "/operations/vehicle/view/:id": [
        //     checkPermission('VIEW_VEHICLES') && { title: "Browse", path: "/vehicle" },
        //     checkPermission('ADD_VEHICLE') && { title: "Add", path: "/vehicles/add" },
        //     // checkPermission('EXPORT_VEHICLE') && { title: "Export", onClick: () => showExportModal() },
        // ].filter(Boolean),
        "/operations/tariffs": [
            checkPermission('VIEW_TARIFF') && { title: "Browse", path: "/operations/tariffs" },
            checkPermission('ADD_TARIFF') && { title: "Add", onClick: () => showAddModal() },
        ].filter(Boolean),
        "/vehicles/views": [
            { title: "Browse", path: "/operations/vehicles" },
            { title: "Add", path: "/operations/vehicle/add" },
            { title: "Export", path: "/operations/vehicles/add" },
        ],
        "/operations/customer": [
            checkPermission("VIEW_CUSTOMERS") && { title: "Browse", path: "/operations/customer" },
            checkPermission("ADD_CUSTOMER") && { title: "Add", onClick: () => navigate("/operations/customer/form") },
        ].filter(Boolean),

        "/operations/customer/form": [
            checkPermission("VIEW_CUSTOMERS") && { title: "Browse", path: "/operations/customer" },
            checkPermission("ADD_CUSTOMER") && { title: "Add", onClick: () => navigate("/operations/customer/form"), path: "/operations/customer/form" },
        ].filter(Boolean),

        "/operations/driver": [
            checkPermission("VIEW_DRIVERS") && { title: "Browse", path: "/operations/driver" },
            checkPermission("ADD_DRIVER") && { title: "Add", onClick: () => navigate("/operations/driver/form") },
        ].filter(Boolean),

        "/operations/driver/form": [
            checkPermission("VIEW_DRIVERS") && { title: "Browse", path: "/operations/driver" },
            checkPermission("ADD_DRIVER") && { title: "Add", onClick: () => navigate("/operations/driver/form"), path: "/operations/driver/form" },
        ].filter(Boolean),

        // '/operations/appointments': [
        //   checkPermission('VIEW_APPOINTMENTS') && { title: "Browse", path: "/operations/appointments" },
        //   checkPermission('ADD_APPOINTMENTS') && { title: "Add", path: "/operations/appointment/add" },
        // ].filter(Boolean),

        '/operations/appointment': appointmentMenu,
        ...(role === ROLES.DRIVER && { '/': appointmentMenu }),

        "/operations/appointment/add": [
            checkPermission('VIEW_APPOINTMENTS') && { title: "Browse", path: "/operations/appointment" },
            checkPermission('ADD_APPOINTMENTS') && { title: "Add", path: "/operations/appointment/add" },
        ].filter(Boolean),

        // "/administrations/employees": [
        //   checkPermission("VIEW_EMPLOYEE") && { title: "Browse", path: "/administrations/employees" },
        //   checkPermission("ADD_EMPLOYEE") && { title: "Add", onClick: () => navigate("/administrations/employees/form"), path: "/administrations/employees/form" },
        // ],
        // "/administrations/employees/form": [
        //   checkPermission("VIEW_EMPLOYEE") && { title: "Browse", path: "/administrations/employees" },
        //   checkPermission("ADD_EMPLOYEE") && { title: "Add", onClick: () => navigate("/administrations/employees/form"), path: "/administrations/employees/form" },
        // ],
        "/operations/loadings": [
            checkPermission('VIEW_LOADPLANS') && { title: "Loaded Plans", path: "/operations/loadings" },
            checkPermission('VIEW_LOADPLANS') && { title: "Saved Plans", path: "/operations/loadings/save-containers" },
            checkPermission('ADD_LOADPLAN') && { title: "Add", path: "/operations/loadings/add" },
            checkPermission('VIEW_CLIENT_REQUEST') && { title: "Clients Request", path: "/operations/loadings/clients" },
            checkPermission('VIEW_IMO') && { title: "IMO’s", path: "/operations/loadings/imo" },
        ].filter(Boolean),
        "/operations/loadings/imo": [
            checkPermission('VIEW_LOADPLANS') && { title: "Loaded Plans", path: "/operations/loadings" },
            checkPermission('VIEW_LOADPLANS') && { title: "Saved Plans", path: "/operations/loadings/save-containers" },
            checkPermission('ADD_LOADPLAN') && { title: "Add", path: "/operations/loadings/add" },
            checkPermission('VIEW_CLIENT_REQUEST') && { title: "Clients Request", path: "/operations/loadings/clients" },
            checkPermission('VIEW_IMO') && { title: "IMO’s", path: "/operations/loadings/imo" },
        ].filter(Boolean),

        "/operations/loadings/save-containers": [
            checkPermission('VIEW_LOADPLANS') && { title: "Loaded Plans", path: "/operations/loadings" },
            checkPermission('VIEW_LOADPLANS') && { title: "Saved Plans", path: "/operations/loadings/save-containers" },
            checkPermission('ADD_LOADPLAN') && { title: "Add", path: "/operations/loadings/add" },
            checkPermission('VIEW_CLIENT_REQUEST') && { title: "Clients Request", path: "/operations/loadings/clients" },
            checkPermission('VIEW_IMO') && { title: "IMO’s", path: "/operations/loadings/imo" },
        ].filter(Boolean),
        "/operations/loadings/add": [
            checkPermission('VIEW_LOADPLANS') && { title: "Loaded Plans", path: "/operations/loadings" },
            checkPermission('VIEW_LOADPLANS') && { title: "Saved Plans", path: "/operations/loadings/save-containers" },
            checkPermission('ADD_LOADPLAN') && { title: "Add", path: "/operations/loadings/add" },
            checkPermission('VIEW_CLIENT_REQUEST') && { title: "Clients Request", path: "/operations/loadings/clients" },
            checkPermission('VIEW_IMO') && { title: "IMO’s", path: "/operations/loadings/imo" },
        ].filter(Boolean),
        "/operations/loadings/clients": [
            { title: "Load Plans", path: "/operations/loadings" },
            { title: "Saved Plans", path: "/operations/loadings/save-containers" },
            { title: "Add", path: "/operations/loadings/add" },
            { title: "Clients Request", path: "/operations/loadings/clients" },
            { title: "IMO’s", path: "/operations/loadings/imo" },
        ],

        "/operations/vendor": [
            checkPermission('VIEW_VENDORS') && { title: "Browse Vendors", path: "/operations/vendor" },
            checkPermission('ADD_VENDOR') && { title: "Add Vendors", onClick: () => navigate("/operations/vendor/form"), path: "/operations/vendor/form" },
            checkPermission('VIEW_VENDOR_QUOTATION') && { title: "Browse Vendor Quotation", path: "/operations/vendor/quotation" },
            checkPermission('ADD_VENDOR_QUOTATION') && { title: "Add Vendor Quotation ", onClick: () => navigate("/operations/vendor/quotation/form"), path: "/operations/vendor/quotation/form" },
        ].filter(Boolean),
        "/operations/vendor/form": [
            checkPermission('VIEW_VENDORS') && { title: "Browse Vendors", path: "/operations/vendor" },
            checkPermission('ADD_VENDOR') && { title: "Add Vendors", onClick: () => navigate("/operations/vendor/form"), path: "/operations/vendor/form" },
            checkPermission('VIEW_VENDOR_QUOTATION') && { title: "Browse Vendor Quotation", path: "/operations/vendor/quotation" },
            checkPermission('ADD_VENDOR_QUOTATION') && { title: "Add Vendor Quotation ", onClick: () => navigate("/operations/vendor/quotation/form"), path: "/operations/vendor/quotation/form" },
        ].filter(Boolean),
        "/operations/vendor/quotation": [
            checkPermission('VIEW_VENDORS') && { title: "Browse Vendors", path: "/operations/vendor" },
            checkPermission('ADD_VENDOR') && { title: "Add Vendors", onClick: () => navigate("/operations/vendor/form"), path: "/operations/vendor/form" },
            checkPermission('VIEW_VENDOR_QUOTATION') && { title: "Browse Vendor Quotation", path: "/operations/vendor/quotation" },
            checkPermission('ADD_VENDOR_QUOTATION') && { title: "Add Vendor Quotation ", onClick: () => navigate("/operations/vendor/quotation/form"), path: "/operations/vendor/quotation/form" },
        ].filter(Boolean),
        "/operations/vendor/quotation/form": [

            checkPermission('VIEW_VENDORS') && { title: "Browse Vendors", path: "/operations/vendor" },
            checkPermission('ADD_VENDOR') && { title: "Add Vendors", onClick: () => navigate("/operations/vendor/form"), path: "/operations/vendor/form" },
            checkPermission('VIEW_VENDOR_QUOTATION') && { title: "Browse Vendor Quotation", path: "/operations/vendor/quotation" },
            checkPermission('ADD_VENDOR_QUOTATION') && { title: "Add Vendor Quotation ", onClick: () => navigate("/operations/vendor/quotation/form"), path: "/operations/vendor/quotation/form" },
        ].filter(Boolean),
        "/administrations/settings": [
            checkPermission("VIEW_SETTINGS") && { title: "Destinations", path: "/administrations/settings" },
            checkPermission("VIEW_SETTINGS") && { title: "Containers size", path: "/administrations/settings/containers" },
            checkPermission("VIEW_SETTINGS") && { title: "Logs", path: "/administrations/settings/logs" },
        ].filter(Boolean),
        "/administrations/settings/containers": [
            checkPermission("VIEW_SETTINGS") && { title: "Destinations", path: "/administrations/settings" },
            checkPermission("VIEW_SETTINGS") && { title: "Containers size", path: "/administrations/settings/containers" },
            checkPermission("VIEW_SETTINGS") && { title: "Logs", path: "/administrations/settings/logs" },
        ].filter(Boolean),
        "/administrations/settings/logs": [
            checkPermission("VIEW_SETTINGS") && { title: "Destinations", path: "/administrations/settings" },
            checkPermission("VIEW_SETTINGS") && { title: "Containers size", path: "/administrations/settings/containers" },
            checkPermission("VIEW_SETTINGS") && { title: "Logs", path: "/administrations/settings/logs" },
        ].filter(Boolean),

        ...(role !== ROLES.CUSTOMER && {
            "/invoice": [
                checkPermission("VIEW_INVOICES") && { title: "Browse", path: "/invoice" },
                checkPermission("ADD_INVOICE") && { title: "Add", path: "/invoice/add" },
            ].filter(Boolean),

            "/invoice/add": [
                checkPermission("VIEW_INVOICES") && { title: "Browse", path: "/invoice" },
                checkPermission("ADD_INVOICE") && { title: "Add", path: "/invoice/add" },
            ].filter(Boolean),
        }),


        "/operations/quotation": [
            checkPermission("VIEW_QUOTATIONS") && { title: "Browse", path: "/operations/quotation" },
            checkPermission("ADD_QUOTATIONS") && { title: "Add", onClick: () => navigate("/operations/quotation/form"), path: "/operations/quotation/form" },
        ].filter(Boolean),
        "/operations/quotation/form": [
            checkPermission("VIEW_QUOTATIONS") && { title: "Browse", path: "/operations/quotation" },
            checkPermission("ADD_QUOTATIONS") && { title: "Add", onClick: () => navigate("/operations/quotation/form"), path: "/operations/quotation/form" },
        ].filter(Boolean),
        "/operations/rate-sending": [
            { title: "Browse", path: "/operations/rate-sending" },
            { title: "Add", onClick: () => navigate("/operations/rate-sending/form"), path: "/operations/rate-sending/form" },
        ].filter(Boolean),
        "/operations/rate-sending/form": [
            { title: "Browse", path: "/operations/rate-sending" },
            { title: "Add", onClick: () => navigate("/operations/rate-sending/form"), path: "/operations/rate-sending/form" },
        ].filter(Boolean),

        // customer portal

        "/customers-portal/appointments": [
            { title: "Browse", path: "/customers-portal/appointments" },
            { title: "Add", path: "/customers-portal/appointments/add-appointments" },
        ],

        "/customers-portal/appointments/add-appointments": [
            { title: "Browse", path: "/customers-portal/appointments" },
            { title: "Add", path: "/customers-portal/appointments/add-appointments" },
        ],

        "/customers-portal/load-plan/create-load-plans": [
            { title: "Loaded Plan", path: "/customers-portal/load-plan/loaded-plan" },
            { title: "Create Load Plans", path: "/customers-portal/load-plan/create-load-plans" },
            // { title: "Open Saved Plans", path: "/customers-portal/open-save-plan" },
            { title: "Send Load Plan", path: "/customers-portal/load-plan/send-load-plan" },
        ],
        "/customers-portal/load-plan/open-save-plan": [
            { title: "Loaded Plan", path: "/customers-portal/load-plan/loaded-plan" },
            { title: "Create Load Plans", path: "/customers-portal/load-plan/create-load-plans" },
            // { title: "Open Saved Plans", path: "/customers-portal/open-save-plan" },
            { title: "Send Load Plan", path: "/customers-portal/load-plan/send-load-plan" },
        ],

        "/customers-portal/load-plan/send-load-plan": [
            { title: "Loaded Plan", path: "/customers-portal/load-plan/loaded-plan" },
            { title: "Create Load Plans", path: "/customers-portal/load-plan/create-load-plans" },
            // { title: "Open Saved Plans", path: "/customers-portal/open-save-plan" },
            { title: "Send Load Plan", path: "/customers-portal/load-plan/send-load-plan" },
        ],
        "/customers-portal/load-plan/loaded-plan": [
            { title: "Loaded Plan", path: "/customers-portal/load-plan/loaded-plan" },
            { title: "Create Load Plans", path: "/customers-portal/load-plan/create-load-plans" },
            // { title: "Open Saved Plans", path: "/customers-portal/open-save-plan" },
            { title: "Send Load Plan", path: "/customers-portal/load-plan/send-load-plan" },
        ],
    };

    const breadcrumbItems = breadcrumbMap[location.pathname] || [];
    const filteredBreadcrumbItems = breadcrumbItems.filter(Boolean);

    const [tickerMessages, setTickerMessages] = useState(() => {
        try {
            const value = localStorage.getItem("ticker");
            const parsed = value ? JSON.parse(value) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    });

    const handleTickerClose = () => {
        localStorage.removeItem("ticker");
        setTickerMessages([]); // hides ticker immediately
    };

    return (
        <Layout style={{ minHeight: "100vh" }} >
            <PresenceProvider user={user}>

                {tickerMessages.length > 0 && (
                    <TopTicker text={tickerMessages} onclose={handleTickerClose} />
                )}

                <HeaderComponent />

                <Layout hasSider style={{ background: '#F5F5F5', display: "flex", justifyItems: "center" }} className='max-w-[1280px] flex gap-4 justify-center mx-auto  w-full'>

                    <Sidebar />

                    <Content style={{}} >
                        <div className='mt-10' >
                            <Title level={4} style={{ marginBottom: 0 }}>{title}</Title>
                        </div>

                        {user && (<GlobalRingingListener user={user} />)}

                        <div className="breadcrumb-container1  my-6">
                            {filteredBreadcrumbItems.length > 0 && (
                                <Breadcrumb separator="">
                                    {breadcrumbItems.map((item, index) => (
                                        <Breadcrumb.Item key={index} className={` breadcrumb-item1 ${location.pathname === item.path ? 'active-link' : ''} `}>
                                            {item.onClick ? (
                                                <Link onClick={(e) => {
                                                    e.preventDefault();
                                                    item.onClick();
                                                }}
                                                >
                                                    {item.title}
                                                </Link>
                                            ) : (
                                                <Link to={item.path}>{item.title}</Link>
                                            )}
                                        </Breadcrumb.Item>))}
                                </Breadcrumb>
                            )}
                            <ModalForm
                                visible={isAddModalVisible}
                                onClose={handleAddCancel}
                                editData={editData}
                                isEditMode={false}
                            />
                            <ScheduleForm
                                visible={isAddModalSchedule} onClose={handleScheduleCancel} editData={editData}
                            />
                        </div>

                        <div className="mt-3  mx-auto ml-1 ">
                            {children}
                        </div>
                    </Content>
                </Layout>
                {/* {
                    role === ROLES.CUSTOMER &&
                    <div className="fixed bottom-40 right-8 flex flex-col items-end gap-20">
                        <div className="flex justify-end">
                            <Link
                                to="/help-center/support"
                                className="rotate-90 origin-bottom-right rounded-xs text-sm 
                                          transform transition-all duration-300 hover:translate-x-[-10px] hover:scale-105"
                            >
                                <Button
                                    size="large"
                                    type="primary"
                                    style={{
                                        border: "none",
                                        borderRadius: "0px",
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                    }}
                                    className="!rounded-none !border-none "
                                >
                                    Chat Support
                                </Button>
                            </Link>
                        </div>

                        <div className="flex justify-end">
                            <Link to="/help-center/feedback" className="rotate-90 origin-bottom-right rounded-xs text-sm 
      transform transition-all duration-300 hover:translate-x-[-10px] hover:scale-105 !rounded-none !border-none">
                                <Button
                                    size="large"
                                    type="primary"
                                    style={{
                                        border: "none",
                                        borderRadius: "0px",
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                    }}
                                >
                                    Feedback
                                </Button>
                            </Link>

                        </div>
                    </div>
                } */}
                <Footer style={{ background: '#FBFBFB' }} className='mt-6 '>
                    {role === ROLES.CUSTOMER ? (
                        <div className='max-w-7xl mx-auto'>
                            <div className='flex justify-between w-full items-center'>
                                <img src={COMPANY_LOGO} style={{ width: "220px", height: "65px" }} alt="Company Logo" />
                                <div className='flex gap-2 justify-center'>
                                    <a href='https://www.facebook.com/ctradeusainc' target='_blank' className='cursor-pointer'>
                                        <img src="/images/Face.png" style={{ width: "30px", height: "30px" }} alt="Company Logo" />
                                    </a>
                                    <a href='https://www.linkedin.com/company/ctradeusainc' target='_blank' className='cursor-pointer'>
                                        <img src="/images/Link.png" style={{ width: "30px", height: "30px" }} alt="Company Logo" />
                                    </a>
                                    <a href='https://www.youtube.com/@ctradeusa' target='_blank' className='cursor-pointer'>
                                        <img src="/images/You.png" style={{ width: "30px", height: "30px" }} alt="Company Logo" />
                                    </a>
                                    <a href='https://www.instagram.com/ctradeusainc' target='_blank' className='cursor-pointer'>
                                        <img src="/images/Insta.png" style={{ width: "30px", height: "30px" }} alt="Company Logo" />
                                    </a>
                                    <a href='https://whatsapp.com/channel/0029VbBLh6OBVJl5IMIcuw0f' target='_blank' className='cursor-pointer'>
                                        <img src="/images/whats.png" style={{ width: "30px", height: "30px" }} alt="Company Logo" />
                                    </a>
                                </div>
                                <div className=''>
                                    <img src="/images/comingsoon.png" style={{ width: "200px", height: "120px" }} alt="Company Logo" />
                                </div>
                            </div>
                            <div className='flex justify-center mt-6' >
                                <ul className='flex gap-10 text-sm' >
                                    <li>Terms & Conditions</li>
                                    <li>Data Privacy Notification</li>
                                    <li>Privacy Policy</li>
                                    <li>Cookie Policy</li>
                                    <li>Unsolicited Submissions Policy</li>
                                </ul>
                            </div>
                        </div>
                    ) :
                        < div className='text-center'>
                            © 2022 - {new Date().getFullYear()} Ctrade USA Inc. All Rights Reserved | Powered By Avantgarde Technology
                        </div>
                    }
                </Footer>
            </PresenceProvider >
        </Layout >
    );
}